import React from 'react';
import { Tag } from 'antd';
import { BulbOutlined } from '@ant-design/icons';
import './QuickQuestions.css';

// 装修场景快捷提问
const quickQuestions = [
  {
    title: '水电改造',
    questions: [
      '水电改造需要注意哪些规范？',
      'GB 50210标准对水电施工有什么要求？',
      '水电改造如何避免后期漏水问题？',
      '强弱电布线间距标准是多少？',
    ],
  },
  {
    title: '泥瓦工',
    questions: [
      '瓷砖铺贴的平整度标准是什么？',
      'GB 50210对墙面抹灰有什么要求？',
      '防水层施工高度标准是多少？',
      '卫生间防水高度180cm是否足够？',
    ],
  },
  {
    title: '软装搭配',
    questions: [
      '如何搭配客厅软装色彩？',
      '小户型软装如何显大？',
      '软装预算如何合理分配？',
      '窗帘、沙发、地毯如何协调搭配？',
    ],
  },
  {
    title: '预算避坑',
    questions: [
      '装修预算如何避免超支？',
      '哪些装修项目容易产生增项？',
      '如何识别装修报价中的陷阱？',
      '装修合同需要注意哪些条款？',
    ],
  },
  {
    title: '材料选择',
    questions: [
      '如何选择环保的装修材料？',
      '地板、瓷砖、木门如何选择？',
      '涂料和壁纸哪个更环保？',
      '装修材料验收标准是什么？',
    ],
  },
];

interface QuickQuestionsProps {
  onQuestionClick?: (question: string) => void;
}

const QuickQuestions: React.FC<QuickQuestionsProps> = ({ onQuestionClick }) => {
  const handleQuestionClick = (question: string) => {
    if (onQuestionClick) {
      onQuestionClick(question);
    } else {
      // 触发快捷提问事件
      const event = new CustomEvent('quickQuestion', { detail: { question } });
      window.dispatchEvent(event);
    }
  };

  return (
    <div className="quick-questions-section">
      <div className="quick-questions-header">
        <BulbOutlined className="quick-questions-icon" style={{ marginRight: 8 }} />
        <h3>装修场景快捷提问</h3>
      </div>
      <div className="quick-questions-grid">
        {quickQuestions.map((category, index) => (
          <div key={index} className="question-category-column">
            <div className="category-title">{category.title}</div>
            <div className="category-questions">
              {category.questions.map((question, qIndex) => (
                <Tag
                  key={qIndex}
                  className="question-tag"
                  onClick={() => handleQuestionClick(question)}
                >
                  {question}
                </Tag>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickQuestions;
